import useLanguageNavigate from '@hooks/useLanguageNavigate';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ListAltIcon from '@mui/icons-material/ListAlt';
// import { Checkbox } from '@mui/material';
import { TaModal } from '@components/shared/TaModal/TaModal';
import SubmitModal from '@features/monitoringOffer/components/SubmitModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUsersStore } from 'services/users/usersStore';

const MonitoringTopicCard = ({ data }: any) => {
	const { t } = useTranslation();
	const [submitModalOpen, setSubmitModalOpen] = useState(false);

	const { user } = useUsersStore();

	const { navigateWithLanguage } = useLanguageNavigate();

	const isFarmerPath = user?.role?.toLowerCase() === 'farmer';

	const toggleSubmitModal = () => {
		setSubmitModalOpen(!submitModalOpen);
	};

	if (!data) return null;

	// Get monitoring ID from data or from localStorage
	const getMonitoringId = () => {
		// First try to get it from the data object
		if (data.monitoring_id) return data.monitoring_id;
		
		// If not available in data, try to get from localStorage
		const selectedOffer = JSON.parse(localStorage.getItem('selectedOffer') || '{}');
		return selectedOffer.id || '';
	};

	const handleOpenGuidelines = () => {
		const monitoringId = getMonitoringId();
		navigateWithLanguage(
			`/${isFarmerPath ? 'farmer' : 'specialist'}/monitoring/project/${data.phases_id}/topics/${data.id}/guidelines?files_count=${data.file_count}`
		);
		localStorage.setItem('topic_id', data?.id);
		// Make sure we store the monitoring ID in localStorage for the guidelines page
		const currentOffer = JSON.parse(localStorage.getItem('selectedOffer') || '{}');
		localStorage.setItem('selectedOffer', JSON.stringify({
			...currentOffer,
			id: monitoringId,
			monitoring_id: monitoringId
		}));
	};

	const handleOpenFiles = () => {
		const monitoringId = getMonitoringId();
		setSubmitModalOpen(!submitModalOpen);
		localStorage.setItem('topic_id', data?.id);
		// Make sure we store the monitoring ID in localStorage for the files modal
		const currentOffer = JSON.parse(localStorage.getItem('selectedOffer') || '{}');
		localStorage.setItem('selectedOffer', JSON.stringify({
			...currentOffer,
			id: monitoringId,
			monitoring_id: monitoringId
		}));
	};

	return (
		<div className="w-full rounded-md shadow-lg bg-white relative flex flex-col">
			{/* Title Section */}
			<div className="flex flex-col items-center justify-center h-1/2 px-4 pt-6 relative mb-2">
				<span className="font-bold text-base text-dark text-center line-clamp-2">
					{data.topic_name}
				</span>
				<div className="absolute top-1 right-1">
					{/* <Checkbox checked={checked} onChange={onToggle} color="primary" sx={{ padding: 0 }} /> */}
				</div>
			</div>

			{/* Buttons Section */}
			<div className="flex flex-col gap-3 h-1/2 bg-gray-100 border-t border-gray-300 w-full items-center justify-center py-3 rounded-b-md">
				<div className="flex flex-row md:flex-col items-center md:items-start gap-6 md:gap-3">
					<button
						className="text-base font-semibold underline text-dark flex items-center gap-1 cursor-pointer"
						onClick={handleOpenGuidelines}
					>
						<ListAltIcon className="text-gray-500" /> {t('guidelines')}
					</button>
					<button
						className="text-base font-semibold underline text-dark flex items-center gap-1 cursor-pointer"
						onClick={handleOpenFiles}
					>
						<AttachFileIcon className="text-gray-500" />
						{t('files')} ({data.file_count || 0})
					</button>
				</div>
			</div>
			<TaModal
				open={submitModalOpen}
				onClose={toggleSubmitModal}
				title={isFarmerPath ? t('submitData') : t('uploadedFiles')}
				showActions={false}
			>
				<div className="flex flex-col gap-[10px] mt-[20px]">
					<SubmitModal onClose={toggleSubmitModal} />
				</div>
			</TaModal>
		</div>
	);
};

export default MonitoringTopicCard;
